import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const DismissedEmployees = ({ setDismissedEmployees, dismissedEmployees, classes, t }) => (
    <FormControlLabel
        className={classes?.marginStates}
        control={(
            <Switch
                checked={!!dismissedEmployees}
                onChange={setDismissedEmployees}
            />
        )}
        label={t('dismissedEmployeesOnly')}
    />
);

export default DismissedEmployees;
